import React from 'react';
import { Github, Linkedin, Globe } from 'lucide-react';
export function Footer() {
  return <footer className="bg-dark-darker pt-20 pb-10 border-t border-white/5" data-id="element-68">
      <div className="max-w-[1320px] mx-auto px-4" data-id="element-69">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-16" data-id="element-70">
          {/* Brand */}
          <div data-id="element-71">
            <a href="#home" className="block mb-6" data-id="element-72">
              <img src="https://cdn.magicpatterns.com/uploads/ryEfGbwwGK21KJ5RXCZhNM/logo11-200x200-1-150x150.png" alt="Sage" className="h-12 w-auto" data-id="element-73" />
            </a>
            <p className="text-white/60 font-inter leading-relaxed max-w-xs" data-id="element-74">
              Web Developer focused on UX and E-Commerce solutions, based in
              Cape Town, South Africa.
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-75">
            <h4 className="text-white font-syne font-bold text-xl mb-6" data-id="element-76">
              Quick Links
            </h4>
            <ul className="space-y-4" data-id="element-77">
              {['About', 'Services', 'Portfolio', 'Contact'].map(link => <li key={link} data-id="element-78">
                  <a href={`#${link.toLowerCase()}`} className="text-white/60 hover:text-gold transition-colors font-inter" data-id="element-79">
                    {link}
                  </a>
                </li>)}
            </ul>
          </div>

          {/* Social */}
          <div data-id="element-80">
            <h4 className="text-white font-syne font-bold text-xl mb-6" data-id="element-81">
              Follow Me
            </h4>
            <div className="flex gap-4" data-id="element-82">
              {[{
              icon: <Linkedin size={20} data-id="element-83" />,
              href: 'https://www.linkedin.com/in/sageartitstudio/'
            }, {
              icon: <Github size={20} data-id="element-84" />,
              href: 'https://github.com/sagestephens'
            }, {
              icon: <Globe size={20} data-id="element-85" />,
              href: 'https://byteweb.co.za/'
            }].map((social, index) => <a key={index} href={social.href} target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-dark-lighter flex items-center justify-center text-white/60 hover:bg-gold hover:text-black transition-all duration-300" data-id="element-86">
                  {social.icon}
                </a>)}
            </div>
          </div>
        </div>

        <div className="border-t border-white/5 pt-8 text-center" data-id="element-87">
          <p className="text-white/40 font-inter text-sm" data-id="element-88">
            © {new Date().getFullYear()} Sage Stephens. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}